import React from 'react';
import { motion } from 'framer-motion';
import { AiOutlineClose, AiOutlineCheck, AiFillClockCircle } from "react-icons/ai";
import './pass_activate.css';

export default function Cards(item) {
    const { note } = item;

    const getCardMod = () => {
        if (note.status === false) return 'pa-card-arch--inactive';
        if (note.status) return 'pa-card-arch--active';
        return 'pa-card-arch--pending';
    };

    const format_data = data => {
        const date = new Date(data);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };

    const cardMod = getCardMod();

    return (
        <motion.div
            initial={{ opacity: 0, y: -16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.12 }}
            style={{ width: '100%' }}
        >
            <div className={`pa-card-arch ${cardMod}`}>
                <div className="pa-card-body-arch">
                    <div className="pa-card-user">{note.user} — {note.name}</div>

                    <div className="pa-card-row">
                        <span className="pa-card-date">С {format_data(note.date_from)}</span>
                        <span className="pa-card-date">По {format_data(note.date_until)}</span>
                    </div>

                    <div className={`pa-card-status ${note.status
                            ? 'pa-card-status--success'
                            : note.status == null
                                ? 'pa-card-status--pending'
                                : 'pa-card-status--danger'
                        }`}>
                        {note.status ? (
                            <><AiOutlineCheck /> Активно</>
                        ) : note.status == null ? (
                            <><AiFillClockCircle /> Ожидание подтверждения</>
                        ) : (
                            <><AiOutlineClose /> Отклонено по причине — {note.message}</>
                        )}
                    </div>
                </div>
            </div>
        </motion.div>
    );
}